import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, HostListener } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ExternalService } from 'src/app/services/external.service';
import { StorageService } from 'src/app/services/storage.service';
import { faAngleLeft, faBars, faAngleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.scss']
})
export class LayoutPageComponent implements AfterViewInit {
  faAngleLeft = faAngleLeft
  faBars = faBars
  faAngleRight=faAngleRight

  private _mobileQueryListener: () => void;
  public opened: boolean = false;
  public openedMenu: boolean = false;
  mobileQuery: MediaQueryList;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private observer: BreakpointObserver, public commonService:CommonService,public storageService:StorageService,
    private externalService:ExternalService) {
    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  title = 'PIF';
  
  toogleMenu() {
    this.opened = !this.opened;
  }
  toogleMenuCenter(){
    this.openedMenu = !this.openedMenu;
  }
  ngOnInit() {

  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 768px)']).subscribe((res) => {
      if (res.matches) {
        this.opened = false;
      } else {
        // this.opened = true;
      }
    });
  }
  
  logOut(){
    var auth = this.storageService.getData('auth')
    var sessionId = this.storageService.getData('sessionId')
    this.externalService.logOut()
  }

}
